
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiDamperHorizontalOn as ObiDamperHorizontalOnElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-damper-horizontal-on.js';
 
 
 

 
 export const ObiDamperHorizontalOn = createComponent({
   react: React,
   tagName: 'obi-damper-horizontal-on',
   elementClass: ObiDamperHorizontalOnElement,
   events: {
     
   }
  });
 
 